'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _authInfo = require('../actions/auth-info');

var Actions = _interopRequireWildcard(_authInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  isLoggedIn: false,
  isAuthenticating: false,
  authInfo: null,
  isLoggingOut: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case Actions.AUTH_START:
      {
        return _extends({}, state, {
          isLoggedIn: false,
          isAuthenticating: true,
          authInfo: null
        });
      }

    case Actions.AUTH_COMPLETE:
      {
        var newAuthInfo = {
          access_token: action.data.access_token,
          token_type: action.data.token_type,
          expires: action.data.expires,
          issued: action.data.issued,
          state: action.data.state
        };

        return _extends({}, state, {
          isLoggedIn: true,
          isAuthenticating: false,
          authInfo: newAuthInfo
        });
      }

    case Actions.AUTH_FAILURE:
      {
        return _extends({}, state, {
          isLoggedIn: false,
          isAuthenticating: false,
          authInfo: null
        });
      }
    case Actions.LOGGING_OUT:
      {
        return _extends({}, state, {
          isLoggingOut: true
        });
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/web/reducers/auth-info.js
// module id = 746
// module chunks = 0